import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
// import "~/channels"
import '@captaincodeman/transition'

Rails.start()
ActiveStorage.start()

import "~/controllers"
